import React, { useState, useMemo, useEffect,useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  FaChevronLeft,
  FaChevronRight,
  FaCaretDown, FaCaretUp
} from "react-icons/fa6";
import { useCart } from "../../context/CartContext";
import { jwtDecode } from "jwt-decode";
import { PetDrawer } from "../../components/PetDrawer/PetDrawer";
import Select from "react-select";
import config from "../../config";

import {
  GiSittingDog,
  GiCat,
  GiCow,
  GiGoat,
  GiRabbit,
  GiSquirrel,
  GiTortoise,
  GiHummingbird,
} from "react-icons/gi";
// --- Time Slot Definitions ---
const TIME_RANGES = {
  morning: {
    startHour: 10,
    endHour: 12,
    label: "Morning Slot",
    range: "10:00 AM – 12:00 PM",
    icon: "🌅",
  },
  afternoon: {
    startHour: 12,
    startMinute: 30,
    endHour: 16,
    label: "Afternoon Slot",
    range: "12:00 PM – 4:00 PM",
    icon: "☀️",
  },
  evening: {
    startHour: 16,
    startMinute: 30,
    endHour: 19,
    label: "Evening Slot",
    range: "4:00 PM – 7:00 PM",
    icon: "🌙",
  },
};

// --- Utility: Generate Date List ---
const generateDates = (days =30) => {
  const today = new Date();
  return Array.from({ length: days }, (_, i) => {
    const date = new Date();
    date.setDate(today.getDate() + i);
    return {
      date:
        i === 0
          ? "Today"
          : i === 1
          ? "Tomorrow"
          : date.toLocaleDateString("en-US", {
              weekday: "short",
              month: "short",
              day: "numeric",
            }),
      //actualDate: date,
      actualDate: formatLocalDate(date),
    };
  });
};

// --- Utility: Filter Available Time Slots ---
const getAvailableSlotGroups = (selectedDateLabel) => {
  const availableGroups = {};
  const now = new Date();
  const isToday = selectedDateLabel === "Today";

  for (const key in TIME_RANGES) {
    const { startHour, endHour, label, range, icon } = TIME_RANGES[key];
    const groupEndMinutes = endHour * 60;
    if (isToday) {
      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      if (currentMinutes < groupEndMinutes - 30)
        availableGroups[key] = { label, range, icon, slots: [label] };
    } else {
      availableGroups[key] = { label, range, icon, slots: [label] };
    }
  }

  const allGroups = {};
  for (const key in TIME_RANGES) {
    allGroups[key] = availableGroups[key] || {
      label: TIME_RANGES[key].label,
      range: TIME_RANGES[key].range,
      icon: TIME_RANGES[key].icon,
      slots: [],
    };
  }
  return allGroups;
};

const formatLocalDate = (dateObj) => {
  if (!dateObj) dateObj = new Date(); // fallback
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

  const getPetIcon = (typeName) => {
  const name = (typeName || "").toLowerCase();

  if (name.includes("dog")) return <GiSittingDog />;
  if (name.includes("cat")) return <GiCat />;
  if (name.includes("cow")) return <GiCow />;
  if (name.includes("goat")) return <GiGoat />;
  if (name.includes("rabbit")) return <GiRabbit />;
  if (name.includes("squirrel")) return <GiSquirrel />;
  if (name.includes("tortoise")) return <GiTortoise />;
  if (name.includes("bird") || name.includes("pigeon"))
    return <GiHummingbird />;

  return <GiSittingDog />; // default fallback
};

 const getShortSize = (sizeLabel) => {
  const size = (sizeLabel || "").toLowerCase();

  if (size === "small") return "S";
  if (size === "medium") return "M";
  if (size === "large") return "L";
  if (size === "giant") return "G";

  return sizeLabel; // fallback
};

// --- Component Start ---
const TimeSlot = ({ pendingService, setPendingService, addToCart }) => {
  const { cartItems } = useCart();
  const [dates] = useState(generateDates());
  const [startIndex, setStartIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState(dates[0].date);
  const [selectedTimeSlotGroup, setSelectedTimeSlotGroup] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [pets, setPets] = useState([]);
  const [petsLoading, setPetsLoading] = useState(true);
  const [selectedPetId, setSelectedPetId] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isPetDetailOpen, setIsPetDetailOpen] = useState(true);
  const [isAddPetDrawerOpen, setIsAddPetDrawerOpen] = useState(false);
  const [isPriceLoading, setIsPriceLoading] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(
    pendingService?.price || pendingService?.basic_price || 0
  );

  const petTypesFromService = pendingService?.pet_type || [];

  const vendorID = pendingService?.vendor_id ||vendorID;

  // --- User Info ---
  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;
  const client_id = decoded?.data?.customer_data?.id;
  const isUserLoggedIn = !!client_id;

  const visibleDates = dates.slice(startIndex, startIndex + 3);
  const slotGroups = useMemo(
    () => getAvailableSlotGroups(selectedDate),
    [selectedDate]
  );
  const [vendorPetTypes, setVendorPetTypes] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedBreed, setSelectedBreed] = useState("");
  const [selectedPetType, setSelectedPetType] = useState(null);

  const [availableBreeds, setAvailableBreeds] = useState([]);
  const [selectedBreedId, setSelectedBreedId] = useState("");

  const [availableSizes, setAvailableSizes] = useState([]);
  const [selectedPetSize, setSelectedPetSize] = useState(null);

  const [masterPetSizes, setMasterPetSizes] = useState([]);

  const [breedsByPetType, setBreedsByPetType] = useState({}); // { [petTypeId]: [breedObj...] }
  const [sizesByPetType, setSizesByPetType] = useState({}); // { [petTypeId]: [sizeObj...] }

  // New states for other service types
  const [frequency, setFrequency] = useState(""); // day_care / dog_walking
  const [numberOfTimes, setNumberOfTimes] = useState(""); // dog_walking (e.g. "1hr")
  const [duration, setDuration] = useState(""); // day_care

  const [errorMsg, setErrorMsg] = useState("");
  const buttonRef = useRef(null);
  const petTypes = (pendingService?.pet_type || []).map((pet) => ({
    pet_type_id: pet.id, // ✅ use master pet type id
    name: pet.name,
  }));

  const [priceMeta, setPriceMeta] = useState({
    base: 0,
    tax: 0,
    surcharges: [],
  });


  const petSizes =
    petTypes?.find((p) => p.pet_type_id === selectedPet?.pet_type)?.sizes || [];

  const normalizedPetTypes = Array.isArray(petTypesFromService)
    ? petTypesFromService
    : [petTypesFromService];

  const allowedPetTypeIds = useMemo(() => {
    if (!pendingService?.pet_type) return [];
    return pendingService.pet_type.map((pt) => pt.id);
  }, [pendingService]);

  const isPetAllowedForService = (pet) => {
    if (!pet?.pet_type) return false;
    return allowedPetTypeIds.includes(pet.pet_type);
  };

  const fetchVendorPetMeta = async (vendorId) => {
    try {
      const url = `${config.API_BASE_URL}/customer/customerpettype?vendor_id=${vendorId}`;

      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const res = await axios.get(url, { headers });

      if (res.data?.status) {
        setVendorPetTypes(res.data.data || []);
      }
    } catch (err) {
      console.error("Pet meta fetch failed:", err);
    }
  };

  useEffect(() => {
    if (!pendingService?.vendor_id) return;
    console.log("Fetching pet meta for vendor:", pendingService.vendor_id);
    fetchVendorPetMeta(pendingService.vendor_id);
  }, [pendingService?.vendor_id]);

  useEffect(() => {
    if (vendorPetTypes.length === 1) {
      setSelectedPetType(vendorPetTypes[0]);
    }
  }, [vendorPetTypes]);

 

  const fetchBreeds = async (petTypeId) => {
    if (!petTypeId) return;

    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/customer/getPetBreeds/`,
        { params: { pet_type: petTypeId } }
      );

      const breeds = res.data?.status ? res.data.data || [] : [];
      setBreedsByPetType((prev) => ({ ...prev, [petTypeId]: breeds }));
      return breeds;
    } catch (err) {
      console.error("Breed fetch failed", err);
      setBreedsByPetType((prev) => ({ ...prev, [petTypeId]: [] }));
      return [];
    }
  };

  const fetchPetSizes = async (petTypeId) => {
    if (!petTypeId || !pendingService?.vendor_id) return [];

    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/customer/getPetsizes/`,
        {
          params: {
            vendor_id: pendingService.vendor_id,
            pet_type: petTypeId,
          },
        }
      );

      const sizes = res.data?.status ? res.data.data || [] : [];
      setSizesByPetType((prev) => ({ ...prev, [petTypeId]: sizes }));
      return sizes;
    } catch (err) {
      console.error("Pet size fetch failed", err);
      setSizesByPetType((prev) => ({ ...prev, [petTypeId]: [] }));
      return [];
    }
  };
  
  const currentPetTypeId = useMemo(() => {
      if (selectedPetId) {
        const pet = pets.find((p) => p._id === selectedPetId);
        return pet?.pet_type;
      }
      // non-logged-in: selectedPetType can be object {pet_type_id} or raw id (saved-pet path)
      return selectedPetType?.pet_type_id ?? selectedPetType;
    }, [selectedPetId, pets, selectedPetType]);

    const sizesForCurrent = useMemo(() => {
      if (!currentPetTypeId) return [];
      return sizesByPetType[currentPetTypeId] || [];
    }, [currentPetTypeId, sizesByPetType]);

    const breedsForCurrent = useMemo(() => {
      if (!currentPetTypeId) return [];
      return breedsByPetType[currentPetTypeId] || [];
    }, [currentPetTypeId, breedsByPetType]);

    const hasAvailableSizes = sizesForCurrent.length > 0;
    const hasAvailableBreeds = breedsForCurrent.length > 0;

    // Pet is "ready" when either a saved pet is chosen OR (new pet type + size/breed only if vendor provides them)
    const isPetDetailReady = useMemo(() => {
      if (selectedPetId) return true;
      if (!selectedPetType) return false;

      const sizeReady = !hasAvailableSizes || !!selectedPetSize?.flps_pet_size_id;
      const breedReady = !hasAvailableBreeds || !!selectedBreedId !== "";
      return sizeReady && breedReady;
    }, [
      selectedPetId,
      selectedPetType,
      hasAvailableSizes,
      hasAvailableBreeds,
      selectedPetSize?.flps_pet_size_id,
      selectedBreedId,
    ]);
      
  useEffect(() => {
    if (isUserLoggedIn) return;
    if (!petTypes || petTypes.length !== 1) return;
    if (selectedPetType) return;
    const singleType = petTypes[0];
    const autoSelect = async () => {
      setSelectedPetType(singleType); // ✅ set full object
      const [sizes, breeds] = await Promise.all([
        fetchPetSizes(singleType.pet_type_id),
        fetchBreeds(singleType.pet_type_id),
      ]);
      setAvailableSizes(sizes || []);
      setAvailableBreeds(breeds || []);
    };
    autoSelect();
  }, [petTypes, isUserLoggedIn]);
  
  // --- Fetch Pets ---
  const fetchPets = async () => {
    const currentToken = localStorage.getItem("token");
    const currentDecoded = currentToken ? jwtDecode(currentToken) : null;
    const currentClientId = currentDecoded?.data?.customer_data?.id;

      if (!client_id) return setPets([]);
      if (!currentClientId) {
      setPets([]);
      setPetsLoading(false);
      return;
    }
    try {
      console.log("Refetching pets for client:", currentClientId);
      const res = await axios.post(
        `${config.API_BASE_URL}/customer/getallpet`,
          { 
        client_id,
        serviceId: pendingService?.service_id, // Pass service ID to get size_price
        serviceType: "grooming" 
      },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const petList = (res.data?.pets || []).map((p) => {
        const _id = p._id || p.id;
        // Normalize breed id and name
        const breed = p.breed || p.breed_id || p.pet_breed || null;
        const breed_name =
          p.breed_name ||
          p.pet_breed_name ||
          (p.breed_info && p.breed_info.name) ||
          null;
        // Normalize size: prefer flps_pet_size_id if present, else numeric/string fallback
        const size = p.size || p.flps_pet_size_id || p.size_id || null;
        const size_label =
          p.size_label || p.sizeLabel || p.size_label_text || null;

        return {
          ...p,
          _id,
          breed,
          breed_name,
          size, // likely flps_pet_size_id (or fallbacks)
          size_label,
        };
      });
      setPets(petList);
    } catch (err) {
      console.error("Error fetching pets:", err);
      setPets([]);
    } finally {
    setPetsLoading(false);        // ← critical
  }
  };

  useEffect(() => {
    fetchPets();
  }, [client_id, token]);

  useEffect(() => {
    if (!Array.isArray(pets) || pets.length === 0 || !pendingService?.vendor_id)
      return;

    const uniquePetTypeIds = [
      ...new Set(pets.map((p) => p.pet_type).filter(Boolean)),
    ];

    uniquePetTypeIds.forEach((typeId) => {
      // Only fetch if not already present
      if (!breedsByPetType[typeId]) fetchBreeds(typeId);
      if (!sizesByPetType[typeId]) fetchPetSizes(typeId);
    });
  }, [pets, pendingService?.vendor_id, breedsByPetType, sizesByPetType]);

  const mapPetToApiPayload = (pet) => {
    if (!pet || !pet.pet_type) return null;

    // 1️⃣ Find available sizes for pet type
    const sizesForType = availableSizes; // already fetched from API for this vendor/pet type
    const matchedSize = sizesForType.find((s) => s.size_label === pet.size);

    if (!matchedSize) return null; // cannot calculate price

    // 2️⃣ Find available breed for pet type
    const matchedBreed = availableBreeds.find((b) => b._id === pet.breed);
    if (!matchedBreed) return null; // cannot calculate price

    return {
      vendor_id: pendingService.vendor_id,
      service_id: pendingService.service_id,
      service_type: normalizedServiceType,
      pet_size: matchedSize.flps_pet_size_id,
      pet_breed: matchedBreed._id,
    };
  };

  useEffect(() => {
    if (!selectedPet || !petSizes.length) return;

    const matchedSize = petSizes.find((s) => s.size_label === selectedPet.size);

    if (matchedSize) {
      setSelectedPetSize({
        flps_pet_size_id: matchedSize.flps_pet_size_id,
        size_label: matchedSize.size_label,
      });
    }
  }, [selectedPet, petSizes]);

  const getSavedPetSizeLabel = (pet) => {
    if (!pet?.size && !pet?.size_label) return "";
    const sizes = sizesByPetType[pet.pet_type] || [];

    // If pet.size is flps_pet_size_id numeric/string, match flps_pet_size_id
    if (pet.size != null) {
      const found = sizes.find(
        (s) => String(s.flps_pet_size_id) === String(pet.size)
      );
      if (found) return found.size_label || "";
    }

    // Fallback to pet.size_label stored on pet
    if (pet.size_label) return pet.size_label;

    // Final fallback: try to match by label (case-insensitive)
    const foundByLabel = sizes.find(
      (s) =>
        String(s.size_label).toLowerCase() === String(pet.size).toLowerCase()
    );
    if (foundByLabel) return foundByLabel.size_label;

    return "";
  };

   useEffect(() => {
       const fetchAllSizes = async () => {
         try {
           // Remove the pet_type filter to get all possible sizes
           const res = await axios.get(
             `${config.API_BASE_URL}/customer/customerpetsize`,
           );
           // Adjust based on whether this "all" API returns .data or .data.data
           setMasterPetSizes(res.data.data || res.data || []);
         } catch (err) {
           console.error("Size fetch error:", err);
         }
       };
       fetchAllSizes();
     }, []);

   const getPetSizeLabel = (pet) => {
     if (!pet) return "Size";
   // map from masterPetSizes by _id
      if (masterPetSizes.length > 0 && pet.size) {
        const mappedSize = masterPetSizes.find(s => String(s._id) === String(pet.size));
        if (mappedSize) {
          const sizeLabel = mappedSize.size_label || mappedSize.name || mappedSize.label;
          if (sizeLabel) return getShortSize(sizeLabel);
        }
      }
      
    return pet.size ? "?" : "Size";
    };

  // Helper: get a human-friendly service label from different shapes of pendingService
  const getPendingServiceLabel = (pending) => {
    if (!pending) return "";

    // If pending already has a readable label
    if (pending.service_category_name) return pending.service_category_name;
    if (pending.service_type && typeof pending.service_type === "string")
      return pending.service_type;

    // If pending is vendor object with services array (your pasted object)
    if (Array.isArray(pending.services) && pending.services.length) {
      // If the pending object contains service_id referencing a chosen service
      if (pending.service_id) {
        const found = pending.services.find(
          (s) =>
            s.service_category_id === pending.service_id ||
            s._id === pending.service_id ||
            s.service_id === pending.service_id
        );
        if (found && found.service_category_name)
          return found.service_category_name;
      }
      // fallback to first service label
      return pending.services[0].service_category_name || "";
    }

    // If pending.service exists and has a category name
    if (pending.service && pending.service.service_category_name)
      return pending.service.service_category_name;

    return "";
  };

  const normalizedServiceType = useMemo(() => {
    const rawLabel = getPendingServiceLabel(pendingService);
    if (!rawLabel) return "";

    const cleaned = String(rawLabel)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9 _]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const map = {
      "grooming salon": "grooming",
      "home grooming": "grooming",
      "mobile pet grooming van": "grooming",

      "day care": "day_care",
      "day care services": "day_care",
      daycare: "day_care",

      "dog walking": "dog_walking",
      dog_walking: "dog_walking",

      "vet clinic": "vet_clinic",
      "pet vet clinic": "vet_clinic",
      vet: "vet_clinic",
      vet_clinic: "vet_clinic",
    };

    return map[cleaned] || cleaned.replace(/\s+/g, "_");
  }, [pendingService]);

  useEffect(() => {
  if (!pendingService) return;

  if (normalizedServiceType === "day_care") {
    // FIX: Look for the specific keys sent by PlanPricing
    setFrequency(pendingService.pricing_frequency || ""); 
    setDuration(pendingService.pricing_duration || "");
  }

  if (normalizedServiceType === "dog_walking") {
    // FIX: Match the keys used in your Step 3 logs
    setFrequency(pendingService.pricing_frequency || "");
    setNumberOfTimes(pendingService.pricing_plan || ""); 
  }
}, [pendingService, normalizedServiceType]);

  // --- Price Calculation ---
  const selectedBreedName = availableBreeds.find(
    (b) => b._id === selectedBreedId
  )?.breed_name;

  const buildPricePayload = () => {
    if (!pendingService) return null;
    const common = {
      vendor_id: pendingService.vendor_id,
      service_id: pendingService.service_id,
      service_type: normalizedServiceType,
    };
    if (selectedPetId) {
      common.pet_id = selectedPetId;
    }

    switch (normalizedServiceType) {
      case "grooming":
        return {
          ...common,
          //pet_size: selectedPetSize?.flps_pet_size_id,
          //pet_breed: selectedBreedId,
          pet_size: hasAvailableSizes ? selectedPetSize?.flps_pet_size_id : 0,
         pet_breed: hasAvailableBreeds ? selectedBreedId : 0,
        };

      case "dog_walking":
        return {
          ...common,
          frequency: frequency || undefined,
          number_of_times: numberOfTimes || undefined,
        };

      case "day_care":
        return {
          ...common,
         // frequency: frequency || undefined,
          //duration: duration || undefined,
          duration: pendingService?.pricing_duration || pendingService?.duration_option,
          frequency: pendingService?.pricing_frequency || pendingService?.plan,
          pet_size: selectedPetSize?.flps_pet_size_id, 
          pet_breed: selectedBreedId,
        
        };
          
      case "vet_clinic":
        // Many vet flows only require vendor + service, but include pet if available
        return {
          ...common,
        };

      default:
        return null;
    }
  };
  const isHomeVariant = useMemo(() => {
    const raw = getPendingServiceLabel(pendingService);
    return /(^|\s|[-_])home($|\s|[-_])/i.test(String(raw || ""));
  }, [pendingService]);
  useEffect(() => {
    console.log("🚀 FINAL API PAYLOAD:",payload);
    console.log("DEBUG PRICE CONDITIONS 👇");
    console.log("vendor_id:", pendingService?.vendor_id);
    console.log("service_id:", pendingService?.service_id);
    console.log("service_type:", pendingService?.service_type);
    console.log("selectedPetSize:", selectedPetSize);
    console.log("selectedBreedId:", selectedBreedId);
  }, [pendingService, selectedPetSize, selectedBreedId]);

  const canCalculatePrice = useMemo(() => {
    if (!pendingService) return false;
    if (!pendingService.vendor_id || !pendingService.service_id) return false;

    switch (normalizedServiceType) {
      case "grooming":
       // return Boolean(selectedPetSize?.flps_pet_size_id && selectedBreedId);
       return isPetDetailReady;

      case "dog_walking":
        return Boolean(frequency && numberOfTimes);

      case "day_care":
        return Boolean(frequency && duration);

      case "vet_clinic":
        // treat vet clinic as calculable immediately (or require pet if your backend needs pet_id)
        return true;

      default:
        return false;
    }
  }, [
    pendingService,
    normalizedServiceType,
    selectedPetSize,
    //selectedBreedId,
    isPetDetailReady,
    frequency,
    numberOfTimes,
    duration,
  ]);

  // Fetch service price
  const fetchServicePrice = async () => {
    if (!canCalculatePrice) return;
    const payload = buildPricePayload();
    if (!payload) return;

    setIsPriceLoading(true);
    try {
      const res = await axios.post(
        `${config.API_BASE_URL}/customer/getServicePriceByPet`,
        payload
      );
      if (res.data?.success) {
       
        
        const data = res.data.data;
    const surcharges = data.surchargeDetails || [];
    
    // Calculate the sum of all surcharges
    const totalSurcharges = surcharges.reduce((sum, s) => sum + s.price, 0);

    setSelectedPrice(data.price);
    setPriceMeta({
      // FIXED: Base is now (Total - Surcharges)
      base: data.price - totalSurcharges, 
      tax: data.taxAmount,
      surcharges: surcharges,
    });
      }
    } catch (err) {
      console.error("Price API failed", err);
    } finally {
      setIsPriceLoading(false);
    }
  };

  useEffect(() => {
    if (!pendingService?.vendor_id || !pendingService?.service_id) return;

    if (normalizedServiceType === "grooming") {
      if (!selectedPetSize?.flps_pet_size_id ) return;
    }

    // --- DOG WALKING: Now waits for a pet ---
  if (normalizedServiceType === "dog_walking") {
    // added !selectedPetId and !selectedPetSize check
    if (!frequency || !numberOfTimes || (!selectedPetId && !selectedPetSize)) return;
  }
  // --- DAY CARE: Now waits for a pet ---
  if (normalizedServiceType === "day_care") {
    // added !selectedPetId and !selectedPetSize check
    if (!frequency || !duration || (!selectedPetId && !selectedPetSize)) return;
  }

    fetchServicePrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      normalizedServiceType,
      selectedPetSize?.flps_pet_size_id,
      selectedBreedId,
      frequency,
      numberOfTimes,
      duration,
      pendingService?.vendor_id,
      pendingService?.service_id,
    ]);


  useEffect(() => {
    if (!canCalculatePrice) return;
    fetchServicePrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canCalculatePrice]);
  //useEffect(() => {
  //  if (
    //  selectedPetId && // saved pet selected
    //  normalizedServiceType === "grooming" &&
    //  selectedPetSize?.flps_pet_size_id &&
    //  selectedBreedId
   // ) {
   //   fetchServicePrice();
   // }
  //}, [
   // selectedPetId,
  //  normalizedServiceType,
  //  selectedPetSize?.flps_pet_size_id,
 //   selectedBreedId,
 // ]);

  useEffect(() => {
    console.log("Price gate:", {
      vendor_id: pendingService?.vendor_id,
      vendor_name: pendingService?.vendor_name,
      service_id: pendingService?.service_id,
      service_type: normalizedServiceType,
      flps_size: selectedPetSize?.flps_pet_size_id,
      breed: selectedBreedId,
      canCalculatePrice,
    });
  }, [
    pendingService,
    normalizedServiceType,
    selectedPetSize,
    selectedBreedId,
    canCalculatePrice,
  ]);

  console.log(
    "service raw label:",
    getPendingServiceLabel(pendingService),
    "normalized:",
    normalizedServiceType,
    "isHome:",
    isHomeVariant
  );
  const payload = buildPricePayload();
  console.log("price payload:", payload);

  // --- UI Handlers ---
  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedTimeSlotGroup(null);
  };

  const handleGroupSelect = (groupKey) => {
    setSelectedTimeSlotGroup(groupKey);
    setSelectedTimeSlot(TIME_RANGES[groupKey].range);
  };

  const handlePetTypeChange = async (e) => {
    const petTypeId = e.target.value;

    // 1. Find the object from the petTypes list
    const petTypeObj = petTypes.find(
      (p) => String(p.pet_type_id) === String(petTypeId)
    );

    setSelectedPetType(petTypeObj || null);

    // 2. Reset dependent states so old data doesn't flicker
    setSelectedPetSize(null);
    setSelectedBreedId("");
    setAvailableSizes([]);
    setAvailableBreeds([]);

    if (!petTypeId) return;

    // 3. Fetch data from APIs
    const [sizes, breeds] = await Promise.all([
      fetchPetSizes(petTypeId),
      fetchBreeds(petTypeId),
    ]);

    // 4. CRITICAL: Update the "Available" states that your UI uses to render buttons
    setAvailableSizes(sizes || []);
    setAvailableBreeds(breeds || []);
  };

  // Replace your current handleSavedPetSelect with this implementation
  const handleSavedPetSelect = async (pet) => {
    const isSame = selectedPetId === pet._id;

    if (isSame) {
      // toggle off
      setSelectedPetId(null);
      setSelectedPetType(null);
      setSelectedPetSize(null);
      setSelectedBreedId("");
      setSelectedPrice(pendingService?.basic_price || 0);
      return;
    }

    // set selected pet id and type (pet.pet_type is an id in your response)
    setSelectedPetId(pet._id);
    setSelectedPetType(pet.pet_type);

    const breedId = pet.breed || pet.breed_id || pet.pet_breed || 0;
     setSelectedBreedId(breedId);

    const sizes = await fetchPetSizes(pet.pet_type); // returns array or []
     const petSizeId = pet.size || pet.flps_pet_size_id || pet.size_id;
    // Try to match by flps_pet_size_id first (saved pet.size may already be an id)
    let matchedSize = sizes.find(
      s => String(s.flps_pet_size_id) === String(petSizeId));
    

    // If not matched and the pet has a stored size_label, match by label (case-insensitive)
    if (!matchedSize && pet.size_label) {
      matchedSize = sizes.find(
        (s) =>
          String(s.size_label).toLowerCase() ===
          String(pet.size_label).toLowerCase()
      );
    }

    if (matchedSize) {
      setSelectedPetSize({
        flps_pet_size_id: matchedSize.flps_pet_size_id,
        size_label: matchedSize.size_label,
      });
    } else {
      // fallback: clear selection (UI will prompt user to pick size)
      setSelectedPetSize(null);
      console.warn(
        "Saved pet size didn't match vendor sizes",
        pet.size,
        pet.size_label,
        sizes
      );
    }

    // set breed id from saved pet (normalize your pet objects so `pet.breed` exists)
    //setSelectedBreedId(pet.breed || "");

    // ensure breeds are loaded for UI
    fetchBreeds(pet.pet_type);
  };

  const nextPage = () =>
    setStartIndex((prev) => (prev + 3 < dates.length ? prev + 3 : 0));
  const prevPage = () =>
    setStartIndex((prev) =>
      prev - 3 >= 0
        ? prev - 3
        : dates.length - (dates.length % 3 === 0 ? 3 : dates.length % 3)
    );

  // --- Confirm Handler ---
  const handleProceed = () => {
    if (!pendingService) return toast.error("Service missing");
    if (!selectedDate || !selectedTimeSlotGroup)
      return toast.error("Select date & time slot");
    if (!selectedPetId && (!selectedPetType || !selectedPetSize))
      return toast.error("Select a pet");

    const selectedDateObj = dates.find((d) => d.date === selectedDate);

    const formattedDate = selectedDateObj?.actualDate;

    console.log("--- THE DATA STRUCTURE ---");
    console.log("TOP LEVEL KEYS:", Object.keys(pendingService));
    console.log("IS SOURCE SERVICE PRESENT?:", !!pendingService.sourceService);
    console.log("FULL OBJECT:", pendingService);

   const finalDuration = pendingService.duration_option || pendingService.duration;
   
   let displayDuration = finalDuration;
    if (normalizedServiceType === "grooming" && finalDuration) {
      const durationNum = parseInt(finalDuration, 10);
      if (!isNaN(durationNum)) {
        displayDuration = `${durationNum} Minutes`;
      }
    }

    const activeVendorId =
      pendingService?.vendor_id ||
      vendorID ||
      localStorage.getItem("vendor_id");
    if (!activeVendorId) {
      toast.error(
        "Your session has timed out. Please refresh the page to continue.",
        {
          duration: 5000,
          position: "top-center",
        }
      );

      return;
    }
    
      const finalData = {
        ...pendingService,
        start_date: formattedDate,
        time_range: selectedTimeSlot,
        frequency: frequency,
       // duration: duration,
        //duration:finalDuration,
        duration: displayDuration,
        pet_type: selectedPetType || pendingService.pet_type,
        petSize: selectedPetSize,
        petBreed: selectedBreedName,
        petBreedId :selectedBreedId,
        price: selectedPrice,
        unit_price: selectedPrice,
        
        item_type: normalizedServiceType,
        priceMeta: {
            base_price: priceMeta.base, 
            surchargeDetails: priceMeta.surcharges,
            taxAmount: priceMeta.tax,
            final_price: selectedPrice,
          },

        ...(selectedPetId ? { vendor_pet_id: selectedPetId } : {}),
        selectedPetName: selectedPetId
          ? pets.find((p) => p._id === selectedPetId)?.name
          : `${selectedPetType} - ${selectedPetSize}`,


        vendor_id: pendingService.vendor_id, 
        vendor_name:pendingService.vendor_name,
         vendor_pet_id: selectedPetId || null, // ✅ pet id
         
         allowedPetTypes: pendingService.pet_type || [],

      };
      console.log("Saving to cart → allowedPetTypes:", pendingService.pet_type);
      console.log("Saving to cart → vendor name:", pendingService.vendor_name);  
      console.log("ADDING ITEM:", finalData);
  

      addToCart(finalData);
      setSelectedPetId(null);
      setSelectedPetType(null);
      setSelectedPetSize(null);
      setSelectedTimeSlotGroup(null);
      setSelectedTimeSlot(null);
     // setPendingService(null);
    };

    
  console.log("🔍 PRICE DEBUG:", {
    normalizedType: normalizedServiceType,
    frequencyState: frequency,
    durationState: duration,
    canCalculate: canCalculatePrice,
    pendingData: {
      pricing_freq: pendingService?.pricing_frequency,
      pricing_dur: pendingService?.pricing_duration
    }
  });
  
  if (!pendingService) return null;

  //const isPetSelected =
    //selectedPetId || (selectedPetType && selectedBreedId && selectedPetSize);
  // const isPetSelected = selectedPetId || isPetDetailReady;
  const isPetSelected =
  selectedPetId ||
  selectedPetType &&
  (!hasAvailableSizes || selectedPetSize) &&
  (!hasAvailableBreeds || selectedBreedId);

  console.log("SELECTED PET TYPE:", selectedPetType);
 
  
  // --- UI ---
  return (
    <div className=" max-w-2xl mx-auto p-4">
      {/* Time Slot Section */}
      <div className="border mb-3 border-gray-200 p-4 rounded-lg shadow-sm bg-white">
        <div
          className="flex items-center gap-4 cursor-pointer text-gray-800"
          onClick={() => setIsOpen(!isOpen)}
        >
          <p className="text-lg font-bold ">Pick a Date
            <span className="text-red-500 ml-1.5">*</span>
          </p>
          {isOpen ? (
            < FaCaretUp className=" text-orange-500 text-2xl" />
          ) : (
            <FaCaretDown className="text-orange-500 text-2xl " />
          )}
        </div>
        {isOpen && (
          <div className="mt-4">
            {/* Date Carousel */}
            <div className="flex items-center ">
              <button
                onClick={prevPage}
                className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full ml-[-14px] hover:bg-gray-200 transition-colors"
              >
                <FaChevronLeft className="text-gray-600 text-xl" />
              </button>
              <div className="flex gap-2 flex-1 overflow-hidden">
                {visibleDates.map((item, idx) => (
                  <div
                    key={idx}
                    onClick={() => handleDateSelect(item.date)}
                    className={`w-full max-w-[110px] flex-shrink-0 p-3 border rounded-lg text-center cursor-pointer transition-all duration-300 ${
                      selectedDate === item.date
                        ? "bg-orange-500 text-white border-orange-500 shadow-md hover:bg-orange-600"
                        : "bg-white border-gray-300 text-gray-700 hover:bg-orange-100 hover:border-orange-300"
                    }`}
                  >
                    <p className="font-semibold text-sm">{item.date}</p>
                  </div>
                ))}
              </div>
              <button
                onClick={nextPage}
                className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full mr-[-14px] hover:bg-gray-200 transition-colors"
              >
                <FaChevronRight className="text-gray-600 text-xl" />
              </button>
            </div>

            {/* Time Slot Buttons */}
            <div className="mt-4">
              <p className="text-md font-semibold text-gray-700 mb-3">Pick Any Time Slot
                <span className="text-red-500 ml-1.5">*</span>
              </p>
              
              </div>
          <div className="mt-4">
          {Object.values(slotGroups).some(group => group.slots.length > 0) ? (    
            <div className="mt-4 grid grid-cols-2 gap-3">           
              {Object.entries(slotGroups).map(
                ([key, { label, icon, range, slots }]) =>
                  slots.length > 0 && (
                    <button
                      key={key}
                      onClick={() => handleGroupSelect(key)}
                      className={`p-3 border-2 rounded-lg text-left transition-all duration-300 ${
                        key === "afternoon" || key === "evening"
                          ? "sm:col-span-1"
                          : ""
                      } ${
                        selectedTimeSlotGroup === key
                          ? "bg-orange-500 text-white border-orange-500 shadow-md hover:bg-orange-600"
                          : "bg-white border-gray-300 text-gray-700 hover:bg-orange-100 hover:border-orange-300"
                      }`}
                    >
                      <p className="font-bold text-sm flex items-center">
                        <span className="mr-2 text-lg">{icon}</span> {label}
                      </p>
                      <p className="text-xs mt-1">{range}</p>
                    </button>
                  )
              )}
            </div>
            ) : (
              <div className="text-center py-6 bg-orange-50 rounded-lg border border-orange-200">
                <p className="text-orange-600 font-medium">⚠️ No slots available for this date</p>
                <p className="text-xs text-orange-400 mt-1">Please choose another date</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Pet Detail Section */}
      <div className="border border-gray-200 p-4 rounded-lg shadow-sm bg-white">
        <div
          className="flex items-center gap-4 cursor-pointer text-gray-800"
          onClick={() => setIsPetDetailOpen(!isPetDetailOpen)}
        >
          <p className="text-lg font-bold">Pet Detail</p>
          {isPetDetailOpen ? (
            <FaCaretUp className="text-orange-500 text-2xl" />
          ) : (
            <FaCaretDown className="text-orange-500 text-2xl" />
          )}
        </div>

        {isPetDetailOpen && (
          <div className="mt-4">
            {/* Logged in user */}
            {isUserLoggedIn ? (
              <>
                {petsLoading ? (
                  <div className="text-center py-10">
                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#FD5901] mx-auto"></div>
                    <p className="mt-4 text-gray-600 font-medium">Loading your pets...</p>
                  </div>
                ) : pets.length > 0 ? (
                  <div className="space-y-3">
                    <p className="text-gray-800 font-bold text-lg">Select Your Pet
                      <span className="text-red-500 font-semibold ml-2">*</span>
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                      {/* Filtered & mapped pets */}
                      {pets.map((pet) => {
                          const isSelected = selectedPetId === pet._id;
                          const foundType = vendorPetTypes.find((t) => {
                            const vendorTypeId = String(t.pet_type_id || t.id || t._id);
                            return vendorTypeId === String(pet.pet_type);
                          });
                          const petTypeName = foundType?.name
                            ? foundType.name.charAt(0).toUpperCase() + foundType.name.slice(1)
                            : "Pet";

                          const breedListForType = breedsByPetType[pet.pet_type] || [];
                          const breedName =
                            breedListForType.find((b) => String(b._id) === String(pet.breed))?.breed_name ||
                            pet.breed_name ||
                            "";
                            const isTypeAllowed = isPetAllowedForService(pet);
    
                          const vendorSizes = sizesByPetType[pet.pet_type] || [];
                          const sizesLoaded = vendorSizes.length > 0;

                          // Size compatibility check
                          let isSizeCompatible = true;
                          let sizeStatus = "";

                          if (sizesLoaded && isTypeAllowed) {
                            const petSizeId = pet.size || pet.flps_pet_size_id || pet.size_id;
                            const petSizeLabel = getSavedPetSizeLabel(pet);

                            isSizeCompatible = vendorSizes.some((vendorSize) => {
                              return (
                                String(vendorSize.flps_pet_size_id) === String(petSizeId) ||
                                (vendorSize.size_label || "").toLowerCase().trim() ===
                                  (petSizeLabel || "").toLowerCase().trim()
                              );
                            });

                            sizeStatus = isSizeCompatible ? " " : "Size not supported";
                          } else if (!isTypeAllowed) {
                            sizeStatus = "Type not supported";
                          } else {
                            sizeStatus = "Checking...";
                          }

                          const isDisabled = !isTypeAllowed || (sizesLoaded && !isSizeCompatible);                                                 

                         return (
                            <button
                              key={pet._id}
                              onClick={() => {
                                if (isDisabled) {
                                  toast.error(isTypeAllowed ? "This pet size is not supported" : "This pet type is not supported for this service");
                                  return;
                                }
                                handleSavedPetSelect(pet);
                              }}
                              disabled={isDisabled}
                              className={`px-3 py-2 border-2 rounded-lg text-left transition-all duration-300 relative overflow-hidden ${
                                isDisabled
                                  ? "bg-red-50 border-red-200 cursor-not-allowed opacity-75"
                                  : isSelected
                                  ? "bg-orange-500 text-white border-orange-500 shadow-md"
                                  : "bg-white border-gray-300 text-gray-700 hover:bg-orange-100 hover:border-orange-300"
                              }`}
                            >
                             <div className="relative z-10">
                                {/* Selected overlay with tick mark - subtle version */}
                                {isSelected && (
                                  <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
                                    <div className="bg-white text-orange-500 rounded-full w-4 h-4 flex items-center justify-center shadow-sm">
                                      <span className="text-sm font-bold">✓</span>
                                    </div>
                                  </div>
                                )}
                                
                                <div className="flex items-center gap-2 mb-1">
                                  <div className="flex items-center gap-2 flex-1 min-w-0">
                                    <p className={`font-semibold text-sm capitalize truncate ${isSelected ? "text-white" : "text-gray-900"}`}>
                                      {pet.name}
                                    </p>
                                    <span className={`text-lg flex-shrink-0 ${isSelected ? "text-white" : "text-gray-700"}`}>
                                      {getPetIcon(petTypeName)}
                                    </span>
                                  </div>
                                </div>
                                <div className="flex items-center gap-2 text-sm">
                                  {/* Size */}
                                      <span
                                        className={`font-semibold ${
                                          isSelected ? "text-white" : "text-grey-700"
                                        }`}
                                      >
                                        {getPetSizeLabel(pet)}
                                      </span>
                                      {/* Breed */}
                                      {breedName && (
                                    <span
                                      className={`text-sm font-medium truncate max-w-[120px] ${
                                        isSelected ? "text-orange-100" : "text-blue-500"
                                      }`}
                                    >
                                      {breedName}
                                    </span>
                                  )}
                                </div>                               

                                {sizeStatus && (
                                  <div className="mt-0">
                                    <span
                                      className={`text-xs font-base ${
                                        sizeStatus === "Checking..."
                                          ? "text-gray-400 italic"
                                          : "text-red-500"
                                      }`}
                                    >
                                      {sizeStatus}
                                    </span>
                                  </div>
                                )}

                              </div>
                            </button>
                          );
                        })}

                      <button
                        onClick={() => setIsAddPetDrawerOpen(true)}
                        className="p-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:bg-orange-100 hover:border-orange-300 transition-colors"
                      >
                        + Add Pet
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-6">
                    <p className="text-gray-600 mb-4">No pets found.</p>
                    <button
                      onClick={() => setIsAddPetDrawerOpen(true)}
                      className="py-2 px-5 bg-[#FD5901] text-white rounded-lg font-medium hover:bg-orange-600 transition-colors"
                    >
                      Add Pet
                    </button>
                  </div>
                )}
              </>
            ) : !isUserLoggedIn ? (
              <div className="space-y-6 pt-2">
                <div>
                  <div className="space-y-6 pt-2">
                    {/* 1️⃣ Pet Type Dropdown */}
                    
                    <div>
                      <p className="text-[#000048] font-semibold mb-2">
                        Pet Type <span className="text-red-500">*</span>
                      </p>

                     {/*<select
                        value={selectedPetType?.pet_type_id || ""}
                        onChange={handlePetTypeChange}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 capitalize"
                      >
                        <option value="">Select Pet Type</option>

                        {petTypes.map((type) => (
                          <option
                            key={type.pet_type_id}
                            value={type.pet_type_id}
                          >
                            {type.name}
                          </option>
                        ))}
                      </select> */}
                     <Select
                      options={petTypes.map(type => ({
                        value: type.pet_type_id,
                        label: type.name
                      }))}
                      value={selectedPetType?.pet_type_id ? {
                        value: selectedPetType.pet_type_id,
                        label: petTypes.find(t => t.pet_type_id === selectedPetType.pet_type_id)?.name
                      } : null}
                      onChange={(option) => {
                        handlePetTypeChange({
                          target: { value: option?.value }
                        });
                      }}
                      placeholder="Select Pet Type"
                      className="w-full"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          minHeight: '42px',
                          fontSize: '18px',
                          borderColor: '#d1d5db',
                          borderRadius: '0.5rem',
                          '&:hover': { borderColor: '#f97316' }
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: '20px',
                          
                        })
                      }}
                    />
                    </div>
                  
                    {/* 2️⃣ Size Buttons (always visible) */}
                    {selectedPetType && hasAvailableSizes && (
                    <div>
                      <p className="text-[#000048] font-semibold mb-2">
                        Pet Size <span className="text-red-500">*</span>
                      </p>
                      {!selectedPetType && (
                        <span className="text-[10px] text-gray-400 italic">Select pet type to see availability</span>
                      )}
                     <div className="flex flex-wrap gap-2">
                          {["Small", "Medium", "Large", "Giant"].map((label) => {
                            // Find if this specific size is in the vendor's available list
                            const sizeData = availableSizes.find(
                              (s) => s.size_label.toLowerCase() === label.toLowerCase()
                            );
                            
                            const isSupported = !!sizeData;
                            const isSelected = selectedPetSize?.size_label === label;

                            return (
                              <div key={label} className="relative group">
                                <button
                                  onClick={() => {
                                    if (isSupported) {
                                      setSelectedPetSize(sizeData);
                                      setSelectedPetId(null);
                                    }
                                  }}
                                  // Disable if not supported OR if pet type hasn't been picked yet
                                  disabled={!isSupported || !selectedPetType}
                                  className={`py-1.5 px-5 rounded-lg border transition-all duration-200 text-sm font-medium relative
                                    ${!selectedPetType 
                                      ? "bg-gray-50 border-gray-200 text-gray-400 cursor-not-allowed" 
                                      : !isSupported 
                                        ? "bg-gray-100 border-gray-200 text-gray-300 cursor-not-allowed overflow-hidden" 
                                        : isSelected
                                          ? "bg-[#FD5901] border-[#FD5901] text-white shadow-md"
                                          : "bg-white border-[#FD5901] text-[#000048] hover:bg-orange-50"
                                    }`}
                                >
                                  {label}
                                  {/* Visual indicator for unsupported sizes */}
                                  {selectedPetType && !isSupported && (
                                    <span className="absolute inset-0 flex items-center justify-center opacity-30">
                                      <div className="w-full h-[1px] bg-gray-500 rotate-12"></div>
                                    </span>
                                  )}
                                </button>

                                {/* Tooltip explaining why it's disabled */}
                                {selectedPetType && !isSupported && (
                                  <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 hidden group-hover:block w-40 bg-gray-800 text-white text-[10px] p-2 rounded shadow-xl z-50 text-center">
                                    The vendor does not provide service for {label} pets.
                                    <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                    </div>
                    )}
                    
                    {/* 3️⃣ Breed Dropdown (always visible) */}
                    {selectedPetType && hasAvailableBreeds && (
                    <div>
                      <p className="text-[#000048] font-semibold mb-2">
                        Breed <span className="text-red-500">*</span>
                      </p>
                            <Select
                              options={availableBreeds}
                              value={availableBreeds.find(b => b._id === selectedBreedId) || null}
                              onChange={(selectedOption) => {
                                setSelectedBreedId(selectedOption?._id || "");
                              }}
                              getOptionLabel={(option) => option.breed_name}
                              getOptionValue={(option) => option._id}
                              placeholder={availableBreeds.length === 0 ? "No breed available" : "Search or select breed..."}
                              isClearable
                              isSearchable
                              isDisabled={!selectedPetType || !selectedPetSize || availableBreeds.length === 0}
                              noOptionsMessage={() => "No breed available"}
                              styles={{
                            control: (base, state) => ({
                              ...base,
                              borderColor: state.isFocused ? '#fd5901' : '#e2e8f0',
                              boxShadow: state.isFocused ? '0 0 0 1px #fd5901' : 'none',
                              '&:hover': {
                                borderColor: '#fd5901'
                              }
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 50
                            }),           
                            }}
                          />
                        </div>
                      )}
                      {/*<select
                        value={selectedBreedId}
                        onChange={(e) => setSelectedBreedId(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2"
                        disabled={!selectedPetType || !selectedPetSize}
                      >
                        {!selectedPetType ? (
                          <option value="">Select Pet Type first</option>
                        ) : !selectedPetSize ? (
                          <option value="">Select Size first</option>
                        ) : availableBreeds.length > 0 ? (
                          <>
                            <option value="">Select Breed</option>
                            {availableBreeds.map((breed) => (
                              <option key={breed._id} value={breed._id}>
                                {breed.breed_name}
                              </option>
                            ))}
                          </>
                        ) : (
                          <option value="">No breed available</option>
                        )}
                      </select>
                    </div>
                    )} */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <p className="text-gray-600 mb-3">No pets found.</p>
                <button
                  onClick={() => setIsAddPetDrawerOpen(true)}
                  className="py-2 px-4 bg-[#FD5901] text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors"
                >
                  Add Pet
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Confirm Button */}
      
      <button
          className={`w-full py-3 mt-4 text-white text-lg rounded-lg transition-colors ${
            !selectedDate || !selectedTimeSlotGroup || !isPetSelected
              ? "bg-orange-400 cursor-not-allowed opacity-50"
              : "bg-[#FD5901] hover:bg-orange-600"
          }`}
          onClick={() => {
            if (!selectedDate) toast.error("Please select a date");
            else if (!selectedTimeSlotGroup) toast.error("Please select a time slot");
            else if (!isPetSelected) toast.error("🐾 Please select a pet");
            else handleProceed();
          }}
        >
        {isPriceLoading
          ? "Calculating Price..."
          : `Confirm & Add to Cart ₹${selectedPrice}`}
      </button>
        <p className="text-center text-sm text-gray-500 mb-2">
          Fields marked with <span className="text-red-500 font-semibold">*</span> are required fields to proceed
        </p>            

      {/* Pet Drawer */}
      <PetDrawer
        isOpen={isAddPetDrawerOpen}
        onClose={() => setIsAddPetDrawerOpen(false)}
        onSave={(newPet) => {
          if (newPet) {
            setPets((prev) => [
              ...prev,
              { ...newPet, _id: newPet._id || newPet.id },
            ]);
          } else {
            fetchPets();
          }
          setIsAddPetDrawerOpen(false);
        }}
      />
    </div>
  );
};

export default TimeSlot;
